import styled from "styled-components";
import PropTypes from "prop-types";
import VoterMatch from "./VoterMatch/VoterMatch";
import VoterLinked from "./VoterLinked/VoterLinked";
import NoMatch from "./NoMatch";

const SectionLabel = styled.div`
  font-size: 12px;
  letter-spacing: 0.08em;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.4);
  text-transform: uppercase;
  margin-bottom: 12px;
`;

const VoterSection = ({ voterConnection }) => {
  const vcStatus = voterConnection?.status;

  let content = <NoMatch />;
  if (vcStatus === "matched")
    content = <VoterMatch candidates={voterConnection.candidates || []} />;
  else if (vcStatus === "linked")
    content = <VoterLinked snapshot={voterConnection.snapshot} />;

  return (
    <>
      <SectionLabel>Voter Registration</SectionLabel>
      {content}
    </>
  );
};

VoterSection.propTypes = {
  voterConnection: PropTypes.object,
};

export default VoterSection;
